const statusColors = {
  active: "bg-primary/10 text-green-700",
  inactive: "bg-red-100 text-red-700",
};
const InfoCard = ({ icon, label, value }) => (
  <div className="bg-slate-50 border border-slate-200 p-4 rounded-xl">
    <div className="text-slate-500 text-sm flex items-center gap-2 mb-1">
      {icon}
      {label}
    </div>
    <div className="text-slate-800 font-medium">{value || "-"}</div>
  </div>
);

const capitalize = (str) => str?.charAt(0).toUpperCase() + str.slice(1);

const ReportDetails = ({ data }) => {
  if (!data) return <div>No data available</div>;

  const { name, email, isActive, reason, comment, type, eventData } = data;
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-slate-800">{name}</h2>
            <p className="text-slate-500 flex items-center gap-2 mt-1">
              {/* <Mail className="w-4 h-4" />  */}
              {email}
            </p>
          </div>

          <span
            className={`px-4 py-1 text-sm rounded-full font-semibold ${
              statusColors[isActive] || "bg-slate-200 text-slate-700"
            }`}
          >
            {isActive}
          </span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <InfoCard
            // icon={<ClipboardList className="w-5 h-5 text-deep-purple0" />}
            label="Query Type"
            value={capitalize(type)}
          />
          <InfoCard
            // icon={<MessageSquare className="w-5 h-5 text-pink-500" />}
            label="Reason"
            value={reason}
          />
          <InfoCard
            // icon={<BadgeCheck className="w-5 h-5 text-green-500" />}
            label="Event Title"
            value={eventData?.title?.en}
          />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-slate-700 mb-2">Comment</h3>
          <p className="bg-slate-50 border border-slate-200 p-4 rounded-xl text-slate-600 text-[15px] leading-relaxed">
            {comment}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReportDetails;
